import { render, staticRenderFns } from "./NewFedExOrUPSEasypostAccount.vue?vue&type=template&id=12590abd&scoped=true&"
import script from "./NewFedExOrUPSEasypostAccount.vue?vue&type=script&lang=ts&"
export * from "./NewFedExOrUPSEasypostAccount.vue?vue&type=script&lang=ts&"
import style0 from "./NewFedExOrUPSEasypostAccount.vue?vue&type=style&index=0&id=12590abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12590abd",
  null
  
)

export default component.exports